import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, map, mergeMap, of } from 'rxjs'
import {
  route_to_action,
  show_display_id_after_created_action,
  show_success_msg_after_updation_action,
  show_error_action
} from '../action/common/common.action'
import { OfflineTrackerService } from 'src/app/services/offline-tracker/offline-tracker.service'
import {
  FETCH_OFFLINE_TRACKER_DETAILS,
  FETCH_OFFLINE_TRACKER_DETAILS_SUCCESS,
  LOAD_OFFLINE_TRACKER_SUMMARY_DETAILS,
  LOAD_OFFLINE_TRACKER_SUMMARY_DETAILS_SUCCESS,
  save_offline_tracker_action,
  save_offline_tracker_success_action,
  UPDATE_OFFLINE_TRACKER_ACTION,
  UPDATE_OFFLINE_TRACKER_SUCCESS_ACTION
} from '../action/offline-tracker.action'

@Injectable()
export class OfflineTrackerEffects {
  constructor(private actions$: Actions, private offlineTrackerService: OfflineTrackerService) {}

  load_offline_tracker_summary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_OFFLINE_TRACKER_SUMMARY_DETAILS),
      mergeMap(data =>
        this.offlineTrackerService.invokeSummaryAPI(data.queryParams, data.searchRequestBody).pipe(
          map(summaryResponse => LOAD_OFFLINE_TRACKER_SUMMARY_DETAILS_SUCCESS(summaryResponse)),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  save_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(save_offline_tracker_action),
      mergeMap(({ offlineTracker, routeTo }) =>
        this.offlineTrackerService.callSaveApi(offlineTracker).pipe(
          mergeMap(response => [
            save_offline_tracker_success_action({ offlineTracker: response, routeTo }),
            route_to_action({ routeTo }),
            show_display_id_after_created_action({ moduleName: 'Offline Tracker', displayId: response?.displayId })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  fetch_details$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FETCH_OFFLINE_TRACKER_DETAILS),
      mergeMap(({ id }) =>
        this.offlineTrackerService.callDetailsApi(id).pipe(
          mergeMap(offlineTracker => [FETCH_OFFLINE_TRACKER_DETAILS_SUCCESS({ offlineTracker })]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  update_activity_details$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UPDATE_OFFLINE_TRACKER_ACTION),
      mergeMap(({ offlineTracker, id, routeTo }) =>
        this.offlineTrackerService.callUpdateApi(offlineTracker, id).pipe(
          mergeMap(activity => [
            UPDATE_OFFLINE_TRACKER_SUCCESS_ACTION({ offlineTracker, routeTo }),
            route_to_action({ routeTo }),
            show_success_msg_after_updation_action({ moduleName: 'Offline Tracker' })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )
}
